import { EditIcon, Paragraph } from '@quickmd-llc/design-system';
import { ConditionQuestion, Question } from '@qmd-types/intakeForms';
import { useIntakeForm } from '../../context/useIntakeForm';

type Props = {
  onEdit: (question: Question) => void;
  question: ConditionQuestion;
};

export function ConditionReviewSection({ onEdit, question }: Props) {
  const { isIntakeFormComplete } = useIntakeForm();
  const selectedOption = question.options.find((option) => option.isSelected);
  const answerText = selectedOption?.name || '--';
  const inputText = selectedOption?.input?.value;

  return (
    <div className="grid gap-0.5">
      <div className="grid gap-0.5">
        <div className="flex items-start justify-between gap-4">
          <Paragraph className="font-semibold">{question.question}</Paragraph>
          {!isIntakeFormComplete && (
            <EditIcon
              className="cursor-pointer"
              onClick={() => onEdit(question)}
              size="lg"
            />
          )}
        </div>

        <Paragraph className="text-shade-80">{answerText}</Paragraph>
      </div>

      {inputText && (
        <Paragraph className="text-shade-80">{inputText}</Paragraph>
      )}
    </div>
  );
}
